// Shared styled components.

import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

export const StyledNoConversationsImg = styled.img`
  margin-bottom: 12px;
`;

export const StyledViewerHeaderDiv = styled.div`
  padding: 0 0 13px 0;
  color: ${(p) => p.theme.greys.shade90};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  line-height: 20px;
  max-width: 480px;
`;

export const StyledViewerBodyDiv = styled.div`
  text-align: center;
  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.medium};
  line-height: 150%;
  max-width: 480px;
`;
